import FieldEditor from "editor/FieldEditor";

class FieldEditorSelect extends FieldEditor {

    create() {
        const $input = this.$input = $("<select>").addClass(this.settings.context === "admin-form" ? "admin-form__select" : "admin-editor admin-editor--select");

        this.settings.options.forEach((option) => {
            if ("string" === typeof option) option = {value: option, label: option};
            $input.append(eotwJSXFactory('option', {value: option.value, selected: option.default, 'data-default': option.default}, [option.label]))
        });
        if (this.settings.context === "admin-form") {
            this.$element.html(
                eotwJSXFactory('div', {class: "admin-form__input-wrap admin-form__input-wrap--half"}, [
                    $input,
                    eotwJSXFactory('span', {class: "admin-form__icon admin-form__icon--select"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.adminBuildUrl + 'base/icons.svg#select-arrow"></use></svg>')
                ])
            );
        } else {
            this.$element.html($input);
        }

        this.$input.on("change", () => {
            this.emit("change", this.getValue());
        })
    }

    destroy() {
        super.destroy();

        this.$element.text(this.getValue());
    }

    getValue() {
        return this.$input.val();
    }

    focus() {
        this.$input.focus();
    }

    setValue(value) {
        if ("undefined" === typeof value) {
            this.$input.find("[data-default]").prop("selected", true);
        } else {
            this.$input.val(value);
        }
    }
}

FieldEditor.register_editor("select", FieldEditorSelect);

export default FieldEditorSelect;
